import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import { ALL_STEPS_LABELS, STEPS_LABELS } from './constants';
import NewImportRequestForm from './new_import_request_form';
import NewImportVerification from './new_import_verification';
import NewImportMapping from './new_import_mapping';
import Mapping from './preview/mapping';
import NewImportPreview from './new_import_preview';
import NewImportRun from './new_import_run';
import NewImportReview from './new_import_review';
import TitleBar from 'components/title_bar';
import Steps from './steps';
import { getCurrentStep, getPaths } from './store/selectors';

export function NewImportRequestView({ currentStep, paths }) {

  const renderLearnMoreLabel = () => {
    if (currentStep === STEPS_LABELS.REVIEW) {
      return (
        <a className="btn btn-save btn-sm" href={paths.databaseSettings}>
          Back to Imports List
        </a>
      );
    }

    return (
      <a className="pull-right js-import-tab" href="#">
        <FontAwesomeIcon icon={faQuestionCircle} />
        <span className="ml-2">Learn more about imports</span>
      </a>
    );
  };

  const renderView = () => {
    return (
      <Switch>
        <Route path="/:id/verification" strict>
          <NewImportVerification />
        </Route>
        <Route path="/:id/map" strict>
          <NewImportMapping />
        </Route>
        <Route path="/:id/mapping" strict>
          <Mapping />
        </Route>
        <Route path="/:id/preview" strict>
          <NewImportPreview />
        </Route>
        <Route path="/:id/run" strict>
          <NewImportRun />
        </Route>
        <Route path="/:id/review" strict>
          <NewImportReview />
        </Route>
        <Route path="/" strict>
          <NewImportRequestForm />
        </Route>
        <Route path="/:id" strict>
          <NewImportRequestForm />
        </Route>
      </Switch>
    );
  };

  return (
    <React.Fragment>
      <TitleBar
        subtitle="Import your data into Buildout"
        title="Import Data"
      >
        {renderLearnMoreLabel()}
      </TitleBar>
      <Steps />
      {renderView()}
    </React.Fragment>
  );
}

NewImportRequestView.propTypes = {
  currentStep: PropTypes.oneOf(ALL_STEPS_LABELS).isRequired,
  paths: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  currentStep: getCurrentStep(state),
  paths: getPaths(state)
});

export default connect(mapStateToProps, null)(NewImportRequestView);
